import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ActivityForm } from 'containers';
import { ErrorBoundary } from 'common/components';
import { base64_decode } from 'util/base64';
export class ActivityEdit extends PureComponent {
  render() {
    const {
      match: {
        params: { id, type, extra = '' },
      },
    } = this.props;
    const ID = id && id !== 'add' ? base64_decode(id) : 'add';
    // field query is inside of activity form to handle the field wrapper theme
    return (
      <ErrorBoundary>
        <ActivityForm id={ID} activityType={type} extra={extra} />
      </ErrorBoundary>
    );
  }
}

ActivityEdit.propTypes = {
  match: PropTypes.object,
};

export default ActivityEdit;



// WEBPACK FOOTER //
// ./src/pages/Activity/Edit/index.js